import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import QueueItem from "../components/QueueItem";
import QueueNav from "../components/QueueNav";
import QueueCompanyFilter from "../components/QueueCompanyFilter";
import TagSearch from "../components/TagSearch";
import request from "request";
import { apiUrl } from "../util";

class StartedQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      allItems: [],
      customers: [],
      sectors: [],
      platform: "all",
      all: false,
      company: null,
      landingPagesOnly: false,
      sort: "time",
    };
  }
  interval = () => {};
  visibleEvent = () => {
    if (!document.hidden) {
      clearInterval(this.interval);
      this.getData();
      this.interval = setInterval(() => {
        this.getData();
      }, 20000);
    } else {
      clearInterval(this.interval);
    }
  };

  componentDidMount() {
    this.getData();
    this.interval = setInterval(() => {
      this.getData();
    }, 120000);
    document.addEventListener("visibilitychange", this.visibleEvent);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    document.removeEventListener("visibilitychange", this.visibleEvent);
  }
  getData = () => {
    const { company, important } = this.state;

    let qs = "";
    if (company) {
      qs = `?company=${company}`;
      if (important) {
        qs = `${qs}&important=true`;
      }
    } else if (important) {
      qs = `?important=true`;
    }
    if (this.state.all) {
      if (qs !== "") {
        qs = `${qs}&all=true`;
      } else {
        qs = `?all=true`;
      }
    }
    request(
      {
        url: `${apiUrl}/queue/${this.props.queue}${qs}`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        json.companies.sort((a, b) => {
          if (a.name && b.name) {
            return a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1;
          }
        });
        if (this.state.items.length !== json.items.length) {
          this.setState({
            items: this.refilterData(json.items),
            allItems: json.items,
            customers: json.customers,
            comps: json.companies,
            companies: json.companies.map(c => ({
              value: c.tld,
              label: `${c.name} (${c.tld})`,
            })),
            sectors: json.sectors.map(c => ({
              value: c,
              label: c,
            })),
          });
        }
      }
    );
  };
  moveToQA = id => {
    request.post(
      {
        url: `${apiUrl}/queue/edit_type`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id, type: "problem" },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  remove = id => {
    this.setState({
      items: [],
    });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/delete`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  showAll = e => {
    e.preventDefault();
    const { company, important } = this.state;

    let qs = "?all=true";

    if (company) {
      qs = `${qs}&company=${company}`;
    }
    if (important) {
      qs = `${qs}&important=true`;
    }
    request(
      {
        url: `${apiUrl}/dev/queue/${this.props.queue}${qs}`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        this.setState({
          items: json.items,
          all: true,
        });
      }
    );
  };
  refilterData = items => {
    const { important, tlds, sects, country, platform } = this.state;

    let retData = items;

    if (important === "landing") {
      retData = items.filter(i => i.landingPage);
    }
    if (country) {
      if (country === "us") {
        retData = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        retData = items.filter(i => {
          if (i.url.endsWith(`#${country}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (platform !== "all") {
      retData = retData.filter(q => q.platform === platform);
    }
    if (tlds && tlds.length > 0) {
      retData = retData.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    if (sects && sects.length > 0) {
      retData = retData.filter(q => {
        let found = false;
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        const company = this.state.comps.find(c => c.tld === tld);
        if (company && company.sectors) {
          sects.forEach(s => {
            if (!found && company.sectors.includes(s)) {
              found = true;
            }
          });
        }

        return found;
      });
    }
    return retData.slice(0, 500);
  };
  filterByCompany = (
    company,
    important,
    country,
    tldsi,
    platform,
    sectorsi
  ) => {
    let items = this.state.allItems;
    let landingPagesOnly = this.state.landingPagesOnly;
    let tlds = tldsi ? tldsi : this.state.tlds;
    let plat = platform ? platform : this.state.platform;
    let cntry = country ? country : this.state.country;
    let sects = sectorsi ? sectorsi : this.state.sects;

    if (company && this.state.company !== company) {
      this.setState(
        {
          company,
        },
        this.getData
      );
      return;
    }
    if (important) {
      if (important === "landing") {
        items = items.filter(i => i.landingPage);
        landingPagesOnly = true;
      } else if (important !== this.state.important) {
        this.setState(
          {
            important: important === "true" ? true : false,
            landingPagesOnly: false,
          },
          this.getData
        );
        return;
      }
    }
    if (cntry) {
      if (cntry === "us") {
        items = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        items = items.filter(i => {
          if (i.url.endsWith(`#${cntry}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (tlds && tlds.length > 0) {
      items = items.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    if (sects && sects.length > 0) {
      items = items.filter(q => {
        let found = false;
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        const company = this.state.comps.find(c => c.tld === tld);
        if (company && company.sectors) {
          sects.forEach(s => {
            if (!found && company.sectors.includes(s)) {
              found = true;
            }
          });
        }

        return found;
      });
    }
    if (plat && plat !== "all") {
      items = items.filter(q => q.platform === plat);
    }
    this.setState({
      items: items.slice(0, 400),
      landingPagesOnly,
      tlds: tlds ? tlds : this.state.tlds,
      sects: sects ? sects : this.state.sects,
      platform: platform ? platform : this.state.platform,
      country: country ? country : this.state.country,
    });
  };
  doTldFilter = tlds => {
    this.filterByCompany(
      this.state.company,
      this.state.important,
      this.state.country,
      tlds,
      this.state.platform,
      this.state.sects
    );
  };
  doSectorFilter = sectors => {
    this.filterByCompany(
      this.state.company,
      this.state.important,
      this.state.country,
      this.state.tlds,
      this.state.platform,
      sectors
    );
  };
  handleSort = sort => {
    this.setState({
      sort,
    });
  };
  getSort = () => {
    const { sort } = this.state;

    if (sort === "time_new") {
      return (a, b) => (a.ctime >= b.ctime ? -1 : 1);
    }
    if (sort === "url") {
      return (a, b) => (a.url >= b.url ? 1 : -1);
    }
    return (a, b) => (a.ctime >= b.ctime ? 1 : -1);
  };
  render() {
    const { user } = this.props;
    const { items, all, sort } = this.state;
    if (sort) {
      items.sort(this.getSort());
    }
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    return (
      <div>
        {this.props.queue === "new" && <h1>Start Detected Queue</h1>}
        {this.props.queue === "ended" && <h1>End Detected Queue</h1>}
        {this.props.queue === "qa" && <h1>Manual Screening Queue</h1>}
        <QueueNav selected={this.props.queue} />
        <QueueCompanyFilter
          selected={this.state.company}
          handleClick={this.filterByCompany}
          handleSort={this.handleSort}
          companies={this.state.customers}
        />
        <div className="w-50">
          <TagSearch
            options={this.state.companies}
            callback={this.doTldFilter}
            placeholder="Filter by company"
          />
        </div>
        <div className="w-50 mv2">
          <TagSearch
            options={this.state.sectors}
            callback={this.doSectorFilter}
            placeholder="Filter by sector"
          />
        </div>
        {items &&
          items.map(item => (
            <QueueItem
              item={item}
              qType="started"
              remove={this.remove}
              moveToQA={this.moveToQA}
              key={item.id}
              user={this.props.user}
              callback={this.getData}
            />
          ))}
        {!all && (
          <p>
            <b>
              <a href="#" onClick={this.showAll}>
                Show all started tests
              </a>
            </b>
          </p>
        )}
      </div>
    );
  }
}

export default StartedQueue;
